import type { ChooseContact } from '@appchoose/contact';
import { contacts } from '@appchoose/contact';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const amDefaultContact = contacts.find((contact) =>
  contact.ids.includes('abir')
)!;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const saleDefaultContact = contacts.find((contact) =>
  contact.ids.includes('floriane')
)!;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const logisticsManagerDefaultContact = contacts.find((contact) =>
  contact.ids.includes('hortense')
)!;

export const findContact = (
  contactName: string | undefined,
  defaultContact: ChooseContact
) => {
  const name = (contactName ?? '').toLowerCase();
  return (
    contacts.find((contact) => contact.ids.includes(name)) ?? defaultContact
  );
};
